import { Link, useMatches, useRouterState } from "@tanstack/react-router"
import { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { getLeafBreadcrumbKeyFromMatches } from "@/app/config/route-static-data"
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@/shared/ui/breadcrumb"
import { getBreadcrumbTrail, navigationConfig } from "@/widgets/layout-sidebar"

/**
 * Breadcrumb component displaying current page context
 * Derives breadcrumb text from navigation configuration and route staticData
 */
export function HeaderBreadcrumb() {
	const { t } = useTranslation()
	const currentPath = useRouterState({
		select: (state) => state.location.pathname,
	})
	const leafLabel = useMatches({
		select: (matches) => getLeafBreadcrumbKeyFromMatches(matches) ?? null,
	})
	const trail = getBreadcrumbTrail(currentPath, navigationConfig, {
		leafLabel,
	})

	if (trail.length === 0) {
		return null
	}

	return (
		<Breadcrumb aria-label={t("navigation.breadcrumbs.ariaLabel")}>
			<BreadcrumbList>
				{trail.map((crumb, index) => {
					const isLast = index === trail.length - 1
					const label = t(crumb.label)

					return (
						<Fragment key={`${crumb.label}-${index}`}>
							{index > 0 ? <BreadcrumbSeparator /> : null}
							<BreadcrumbItem>
								{isLast ? (
									<BreadcrumbPage>{label}</BreadcrumbPage>
								) : crumb.route ? (
									<BreadcrumbLink asChild>
										<Link to={crumb.route}>{label}</Link>
									</BreadcrumbLink>
								) : (
									<span className="font-normal text-muted-foreground">
										{label}
									</span>
								)}
							</BreadcrumbItem>
						</Fragment>
					)
				})}
			</BreadcrumbList>
		</Breadcrumb>
	)
}
